const REDDIT_ATTRIBUTION_MAX_STRING_LENGTH = 500;

const isBrowser = () => typeof window !== "undefined";

const isRedditPixelEnabled = () => {
  return isBrowser() && window.__instantTranscriberMarketingConsent !== false;
};

const cleanRedditValue = (value) => {
  if (value == null) return undefined;
  const normalized = String(value).slice(0, REDDIT_ATTRIBUTION_MAX_STRING_LENGTH);
  return normalized || undefined;
};

const readCookie = (name) => {
  if (!isBrowser() || !name) return undefined;
  const prefix = `${name}=`;
  const cookie = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  if (!cookie) return undefined;
  try {
    return decodeURIComponent(cookie.slice(prefix.length));
  } catch {
    return cookie.slice(prefix.length);
  }
};

const getUrlParam = (name) => {
  if (!isBrowser()) return undefined;
  try {
    return new URLSearchParams(window.location.search).get(name) || undefined;
  } catch {
    return undefined;
  }
};

export const getRedditAttributionParams = () => {
  if (!isRedditPixelEnabled()) return {};

  const params = {
    reddit_rdt_cid: getUrlParam("rdt_cid") || getUrlParam("reddit_rdt_cid"),
    reddit_uuid: readCookie("_rdt_uuid") || getUrlParam("reddit_uuid"),
  };

  return Object.fromEntries(
    Object.entries(params)
      .map(([key, value]) => [key, cleanRedditValue(value)])
      .filter(([, value]) => value !== undefined),
  );
};

export const appendRedditAttributionParams = (url) => {
  const nextUrl = url instanceof URL ? url : new URL(url);
  const params = getRedditAttributionParams();

  Object.entries(params).forEach(([key, value]) => {
    nextUrl.searchParams.set(key, value);
  });

  return nextUrl;
};
